/* DON'T EDIT THIS FILE: edit original and run build again */ import { BaseSgrOnboardingOptions } from "../../../framework/tenant-handlers/base-sgr-onboarding-options.ts";

class BindOnboardingOptions extends BaseSgrOnboardingOptions {
  hasSignatura(): boolean {
    return false;
  }

  hasAccounts(): boolean {
    return true;
  }

  allowForeignCompanies(): boolean {
    return true;
  }

  hasRevenueVolume(): boolean {
    return false;
  }

  hasSwornStatement(): boolean {
    return true;
  }

  useSnailMailViaEmail(): boolean {
    return false;
  }

  getSnailMailSignatureAddress(): string {
    return "Dirección 888 P1 - Bind - CABA";
  }

  getEmailAfterLabelText(): string | null {
    return null;
  }

  getOpenAccountAgreementLabel(): string {
    return "Aceptación de carta oferta de contrato de garantía recíproca";
  }

  hasPositionFieldRequired(): boolean {
    return true;
  }

  financialGuaranteeAmountLimit(): number | null {
    return 360000000;
  }
}

export const bindOnboardingOptions = new BindOnboardingOptions();
